(() => {
  const desktopHoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const gallerySelector = '[data-custom-mobile-collection-gallery], [data-custom-bridal-gallery]';

  const getIndexButton = (gallery, index) => {
    if (gallery.hasAttribute('data-custom-mobile-collection-gallery')) {
      return gallery.querySelector(`[data-custom-mobile-collection-gallery-index="${index}"]`);
    }

    return gallery.querySelector(`[data-custom-bridal-gallery-index="${index}"]`);
  };

  const showIndex = (gallery, index) => {
    const button = getIndexButton(gallery, index);
    if (!button || Number.parseInt(gallery.dataset.galleryIndex || '0', 10) === index) return;
    button.click();
  };

  const showIndexWhenReady = (gallery, index, shouldContinue, attempt = 0) => {
    if (!shouldContinue() || attempt > 100) return;
    if (gallery.dataset.galleryAnimating === 'true') {
      window.setTimeout(() => showIndexWhenReady(gallery, index, shouldContinue, attempt + 1), 40);
      return;
    }
    showIndex(gallery, index);
  };

  document.addEventListener('pointerover', (event) => {
    if (!desktopHoverQuery.matches || !(event.target instanceof Element)) return;

    const gallery = event.target.closest(gallerySelector);
    if (!gallery || (event.relatedTarget instanceof Node && gallery.contains(event.relatedTarget))) return;

    gallery.dataset.customDesktopSecondImageHover = 'true';
    showIndexWhenReady(
      gallery,
      1,
      () => desktopHoverQuery.matches && gallery.dataset.customDesktopSecondImageHover === 'true'
    );
  });

  document.addEventListener('pointerout', (event) => {
    if (!(event.target instanceof Element)) return;

    const gallery = event.target.closest(gallerySelector);
    if (
      !gallery ||
      gallery.dataset.customDesktopSecondImageHover !== 'true' ||
      (event.relatedTarget instanceof Node && gallery.contains(event.relatedTarget))
    ) {
      return;
    }

    delete gallery.dataset.customDesktopSecondImageHover;
    showIndexWhenReady(
      gallery,
      0,
      () => desktopHoverQuery.matches && gallery.dataset.customDesktopSecondImageHover !== 'true'
    );
  });
})();
